<template>
<div class="main my">
  <!-- 场馆配置页 -->
  <form class="clear bcw ptw" @submit.prevent="checkForm" v-cloak>
    <van-cell-group>
      <van-cell
          title="城市选择"
          v-model="clubAreaTips"
          @click="areaPopupShow = true"
          is-link/>
      <van-cell
          title="场馆位置"
          v-model="clubGridTips"
          is-link
          @click="selectGrid"
          value="北京" />
      <van-field v-model="postForm.address" label="详细地址" clearable placeholder="请输入" />
      <van-field v-model="postForm.contact" label="联系电话" clearable type="tel" placeholder="请输入" /> 
    </van-cell-group>
    <the-btnbar :loadSta="subSta"></the-btnbar>
  </form>

  <!-- 选择城市弹出层 -->
  <van-popup v-model="areaPopupShow" position="bottom">
      <van-area
          @cancel="areaPopupShow = false"
          @confirm="getArea"
          :area-list="arealist"/>
  </van-popup>
  <!-- 选择位置坐标弹出层 -->
  <van-popup class="club-grid" v-model="gridPopupShow">
      <iframe id="mapPage" width="100%" height="100%" frameborder=0
          src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp">                    
      </iframe>
  </van-popup>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import TheBtnbar from './components/TheBtnBar';
import AreaList from '@/assets/scripts/area';
import {
  Button,
  Row,Popup,
  Col,Toast
} from 'vant';

Vue.use(Button).use(Row).use(Popup).use(Col).use(Toast);

export default {
  components: {
    TheBtnbar
  },
  data() {
    return {
      subSta:false, //提交时 按钮状态
      clubInfo: {}, // 当前俱乐部信息
      postForm:{},

      clubAreaTips:'请选择',
      arealist:AreaList,
      areaPopupShow: false,

      clubGridTips:'请选择',
      gridPopupShow: false,
    }
  },
  created(){
    // 获取俱乐部信息
    this.$http.post('club_manage/getInfo').then(res => {
      if (!res.data.code) {
        this.postForm = res.data.value
        this.clubAreaTips =res.data.value.province + '-' + res.data.value.city + '-' + res.data.value.county //城市
      } else {
        Toast.fail(res.data.message);
      }
    })
  },
  methods: {
    selectGrid:function(){
        // 选择位置坐标
        let _this = this;
        window.addEventListener('message', function(event) {
            // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
            // console.log(event)
            var loc = event.data;
            if (loc && loc.module == 'locationPicker') {
                //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                _this.postForm.longitude = loc.latlng.lng;
                _this.postForm.latitude = loc.latlng.lat;
                _this.clubGridTips = loc.poiname;
                _this.postForm.address = loc.poiaddress;
                _this.gridPopupShow = false;
                // console.log(loc)
            }
        }, false);
        this.gridPopupShow = true;
    },
    getArea: function(area){
      // 选择城市组件 选择后回调方法
        this.postForm.province = area[0].name;
        this.postForm.city = area[1].name;
        this.postForm.county = area[2].name;
        this.clubAreaTips = area[0].name + '-' + area[1].name + '-' + area[2].name;
        this.areaPopupShow = false;
    },
    checkForm: function(){
      // console.log(this.postForm)

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))
      _this.subSta = true
      // 提交表单
      _this.$http.post('club_manage/edit',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'编辑成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.club-grid{
    width: 100%; height: 100%;
    &>iframe{
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/SetClubStore.vue